import { toast } from "react-toastify";
import axiosInstance from "../../../Utils/axiosInstance";


export const handleDataDownload = async (
    endpoint: string,
    fileName: string
): Promise<void> => {
    try {
        const response = await axiosInstance.get(endpoint, {
            responseType: "blob",
            headers: {
                "Content-Type": "application/json",
            },
        });

        if (!response.data) {
            throw new Error("No data received from server");
        }

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();

        setTimeout(() => {
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        }, 100);

        toast.success("Data downloaded successfully!");
    } catch (error) {
        console.error("Download error:", error);
        toast.error("Failed to download data");
    }
};